import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment'
import axios from 'axios';
import * as queryString from 'querystring';

@Injectable()
export class LinenotificationService {
    constructor() {
    }

    async request(data) {
        return {
            method: data.method ? data.method : 'get',
            url: data.url,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'cache-control': 'no-cache',
            },
            data: queryString.stringify(data.params)
        };
    }

    async sendNoti(message) {
        return axios(await this.request({
            method: 'post',
            url: environment.LINE_NOTI_API,
            params: {message: JSON.stringify(message)}
        }))
            .then((response) => {
                return response;
            })
            .catch(error => {
                return error;
            });
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/service/linenotification.service.ts